import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import styles from "./AddNotifsEmail.module.scss";
import cn from "classnames";
import Title from "@components/global/new/Title/Title";
import Field from "@components/global/new/Field/Field";
import Button from "@components/global/new/Button/Button";
import { useAddNotifsEmailControl } from "./useAddNotifsEmailControl";
import Loader from "@components/global/Loader/Loader";

function AddNotifsEmail(props: CommonModalPropsI) {
  const control = useAddNotifsEmailControl(props);
  return (
    <div className={styles.wrapper}>
      {control.loading && <Loader />}
      <Title className={styles.title}>
        {props.formatMessage({ id: "modal.add_email.title" })}
      </Title>

      <form className={styles.content} onSubmit={control.onSubmit}>
        <Field
          type='email'
          name={props.formatMessage({ id: "modal.add_email.email" })}
          id='email'
        />
        <Button type='submit'>
          {props.formatMessage({ id: "modal.add_email.apply" })}
        </Button>
      </form>
    </div>
  );
}

export default WithModal(MODALS_ENUM.ADD_NEW_NOTIFS_EMAIL, AddNotifsEmail);
